import {Status} from "../models/status";

export class StatusHelper {
  public static getItemStyle(state: Status | undefined): string {
    if (state == undefined) {
      return "";
    }
    let css = "";
    if ((state.backColor ?? "") != "") {
      css = "background-color: #" + state.backColor + ";";
    }
    if ((state.textColor ?? "") != "") {
      css = css + "color: #" + state.textColor + ";";
    }
    return css;
  }
}
